import React from "react";
import EnvironmentForm from "./EnvironmentForm";
import { useTranslation } from 'react-i18next';

const AddEnvironmentPage = () => {
  const { t } = useTranslation();

  return (
    <div id="content">
      <div id="content-title">{t('add_environment')}</div>

      <div className="content-bubble">
        <EnvironmentForm />
      </div>
    </div>
  );
};

export default AddEnvironmentPage;
